import React from 'react'
import PropTypes from 'prop-types'
import './statistics.css'
import { joinClassList } from '../utilities/utilities.js'
import { camelCase } from 'lodash'
import { getBackgroundColor } from './statsUtils.js'
import { getMargins } from '../../utility'

export const getStatisticsParameters = (parameters) => {
  return {
    layout: camelCase(parameters.layout) || 'horizontal',
    backgroundColor: getBackgroundColor(parameters.backgroundColor),
    marginTop: parameters.marginTop || 'No Spacing',
    marginBottom: parameters.marginBottom || 'No Spacing',
    reduceTopSpacing: parameters.reduceTopSpacing === true,
    hideOnMobile: parameters.hideOnMobile === true,
  }
}

const Statistics = ({ children, ...props }) => {
  const {
    backgroundColor,
    layout = 'horizontal',
    desktopBackground,
    mobileBackground,
    marginTop,
    marginBottom,
    reduceTopSpacing = false,
    hideOnMobile = false,
  } = props
  const isDesktop = matchMedia('(min-width: 1370px)').matches
  const imgSrc = isDesktop ? desktopBackground : mobileBackground

  const statsWrapperClasses = joinClassList([
    'Statistics',
    'u-paddingVert12gu',
    getMargins(marginTop, marginBottom),
    backgroundColor,
    layout === 'inset' ? 'u-sizeConstrained' : '',
    reduceTopSpacing ? 'Statistics--reduceTopSpacing' : '',
    hideOnMobile ? 'u-sm-hidden' : '',
    hideOnMobile ? 'u-md-hidden' : '',
    'u-posRelative',
  ])

  return (
    <div className={statsWrapperClasses}>
      {imgSrc && <img src={`${imgSrc}`} alt="" />}
      <div className="u-sizeConstrained">{children}</div>
    </div>
  )
}

Statistics.propTypes = {
  backgroundColor: PropTypes.string,
  desktopBackground: PropTypes.string,
  ctaAlignment: PropTypes.oneOf(['left', 'center']),
  layout: PropTypes.oneOf(['horizontal', 'vertical', 'inset']),
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  reduceTopSpacing: PropTypes.bool,
  hideOnMobile: PropTypes.bool,
}

export default Statistics
